import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
}

function isEmpty(value: React.ReactNode) {
  return value === null || value === undefined || value === "-" || value === "";
}

export default function DetailRow({ label, value }: DetailRowProps) {
  if (isEmpty(value)) return null;
  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {label}
      </Typography>
      {/* A div, so a value may hold chips, avatars or other blocks. */}
      <Typography variant="body2" component="div">
        {value}
      </Typography>
    </Box>
  );
}

/** A DetailRow in a half-width (or `wide`) grid cell; renders no cell when empty. */
export function DetailGridItem({ wide, ...props }: DetailRowProps & { wide?: boolean }) {
  if (isEmpty(props.value)) return null;
  return (
    <Grid size={wide ? { xs: 12 } : { xs: 12, sm: 6 }}>
      <DetailRow {...props} />
    </Grid>
  );
}
